import { useQuery } from '@tanstack/vue-query';
import { api } from '/app/plugins/services';
import { useAuth } from '/app/composables/auth';
import { computed } from 'vue';

export const useFeatureFlag = () => {
    const { auth } = useAuth();
    const context = computed(() => {
        return auth.user.id || 'anonymous';
    });

    return useQuery({
        queryKey: ['app', 'feature-flag', context],
        queryFn: async () => {
            const { data: response } = await api.flags();
            
            return response?.data ?? {};
        },
    });
}